export default __webpack_public_path__ + "static/normalized_bbc-67689e4b2f8dd6b7d3913e4c0ee6c22f.svg";